import PlanDetailsCompareDialog from './plan-details.vue';
import FullComparisonDialog from './full-comparison-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { mapState } from 'vuex';
import { isAutoAddable } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  props: {
    showPlanDetails: Boolean,
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    })
  },
  created() {
    this.planDetailsCompareDialog = new ServiceConfirm(PlanDetailsCompareDialog);
    this.fullComparisonDialog = new ServiceConfirm(FullComparisonDialog);
  },
  methods: {
    async showPlanDetailDialog() {
      if (this.$context.is.modalDelta && isAutoAddable()) {
        this.$emit('view-details');
      } else {
        // do tracking when open plan details dialog
        this.$tracking.buyInteraction('plan details selected',this.trackingPlanKey);

        // Directly show full comparison dialog
        await this.fullComparisonDialog.confirm({
          planType: this.planType,
        }).catch(() => {
          console.log('fullComparisonDialog closed');
          // if (this.$context.is.modal) {
          //   this.showPlanDetailDialog();
          // }
        });
      }
    },
  },
};
